module.exports = __webpack_public_path__ + "h5/img/lc_share.8a943534.png";